import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../api/supabase';

const AuthCallback = () => {
  const [message, setMessage] = useState('Processing authentication...');
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the URL hash and handle the auth callback
        const { error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Error during auth callback:', error);
          setMessage('Authentication failed. Please try again.');
          setTimeout(() => navigate('/login'), 3000);
          return;
        }
        
        setMessage('Authentication successful! Redirecting...');
        setTimeout(() => navigate('/'), 2000);
      } catch (err) {
        console.error('Unexpected error during auth callback:', err);
        setMessage('An unexpected error occurred. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="auth-callback-container">
      <div className="auth-callback-card">
        <h2>Authentication</h2>
        <p>{message}</p>
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default AuthCallback; 